"use strict";

exports.__esModule = true;
exports.simpleMemoize = simpleMemoize;

function simpleMemoize(f) {
  let cache = {};

  function memoized(...args) {
    const index = JSON.stringify(args);

    if (cache[index]) {
      return cache[index];
    } else {
      const result = f(...args);
      cache[index] = result;
      return result;
    }
  }

  memoized.clearCache = () => cache = {}; // @ts-ignore


  return memoized;
}
//# sourceMappingURL=simpleMemoize.js.map